import React, { useState } from 'react';
import { InfoCircle } from "react-bootstrap-icons";
import Alert from 'react-bootstrap/Alert';
import { useCookies, withCookies } from "react-cookie";
import { useTranslation } from 'react-i18next';
import './CookiesPrompt.scss';

function CookiesPrompt() {
  const [show, setShow] = useState(true);
  const [cookies, setCookie] = useCookies(["cookies_acceptance"]);
  const { t } = useTranslation();

  function acceptCookies() {
    setCookie("cookies_acceptance", "true", {
      path: "/"
    });
    setShow(false);
  }

  if (cookies.cookies_acceptance === 'true' || !show || true) return null;

  return (
    <div className="message-wrapper">
      <Alert className='message-component'
        variant="info"
        dismissible
        onClose={acceptCookies}>
        <InfoCircle className='message-prompt-info-icon'></InfoCircle>
        <p className='message-prompt-text text-2 m-0'>
          {t('influencers.common.cookies.desktop')}
        </p>
      </Alert>
    </div>);

}

export default withCookies(CookiesPrompt);
